import React from "react";

import { ReactComponent as StartOutline } from "../../../assets/svg/star-outline.svg";
import { ReactComponent as StartBlue } from "../../../assets/svg/star-outline-blue.svg";

const WidgetRating: React.FC<any> = ({ avgRating, height }) => {
  const tempStars = Array.from({ length: 5 }, (_, index) => {
    const number = index + 0.5;
    return (
      <span key={index}>
        {avgRating >= index + 1 ? (
          <StartBlue fill="#1D7AFF" height={height} />
        ) : avgRating >= number ? (
          <StartBlue height={height} fill="#1D7AFF" />
        ) : (
          <StartOutline height={height}/>
        )}
      </span>
    );
  });
  return (
    <div style={{ margin: "8px 0" }}>
      <div className="stars">{tempStars}</div>
    </div>
  );
};

export default WidgetRating;
